import React from 'react'

import './styles.scss'
import { getStaticImage } from 'utils/statics'

const Input = props => {
  const { withSearchIcon, label, placeholder, value, onChange } = props

  return (
    <div className='folders-view-input'>
      {label ? <label className='folders-view-input__label'>{label}</label> : null}
      <div className='folders-view-input__input-container'>
        {withSearchIcon ? (
          <figure className='folders-view-input__icon'>
            <img src={getStaticImage('/icons/orange-brand/icon-search-grey.svg')} alt='Search' />
          </figure>
        ) : null}
        <input
          className='folders-view-input__input'
          type='text'
          placeholder={placeholder}
          value={value}
          onChange={({ target: { value } }) => onChange(value)}
        />
        {value ? (
          <button className='folders-view-input__btn' onClick={() => onChange('')}>
            <figure className='folders-view-input__icon'>
              <img src={getStaticImage('/icons/orange-brand/icon-close-slim-grey.svg')} alt='Clean' />
            </figure>
          </button>
        ) : null}
      </div>
    </div>
  )
}

export default Input
